export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/starStruckEmoji.26e02d37.svg","height":169,"width":159};